<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter_3">
<a id="page_18"></a>
<h1 class="chtitle"><a href="#/text/9780062192523_Contents#Chapter_3"><img alt="image" class="epubimage" src="images/ch03.jpg"/></a></h1>
<p class="noIndent">“<span class="dp">M</span>r. Walker?” Angel asked, suddenly worried about his job. “I’m sorry. I didn’t recognize you!”</p>
<p>Their father would have been hard for anyone to recognize. He was wearing a ski jacket, torn jeans, loafers without socks, a tattered San Francisco Giants cap, and aviator sunglasses, with a plaid scarf wrapped around his neck. He was crossing the street in a hurry, headed for a deli, while a double-parked cab waited across the way. Mr. Walker saw Angel and put on a smile.</p>
<p>“Kids! Hey! Angel, don’t worry about it.” He walked to the rear passenger window. Cars honked at him. He looked like he’d been up all night.</p>
<p>“Mom said you were out for a run,” Brendan said.</p>
<a id="page_19"></a>
<p>“I was working. Your mother tries to shield you from the amount of work I do. But I’m really trying to get my old position back, and that means doing time-consuming research.”</p>
<p>“We understand,” Eleanor said. “We love you, Dad.”</p>
<p>“What kind of research?” Brendan asked, concerned about his dad—and wanting to believe him.</p>
<p>“Medical research. Blood flow and reward centers in the brain. Look, I’m grabbing a sandwich and going home. You kids have a great day at school. I love you.” He kissed his hand, reached through the window, and patted each of their heads.</p>
<p>Then he was off, into the deli. The Walkers looked at one another.</p>
<p>“Maybe he’s going insane. Maybe the book cursed him,” Cordelia said.</p>
<p>“Or maybe he’s just got too much money,” said Brendan.</p>
<p>“Maybe I should have wished for like half as much,” Eleanor said guiltily.</p>
<p>They rode in silence the rest of the way to school.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062192523_Chapter_3.vue?160f90c6